import { useTranslation } from 'react-i18next';
import NoItemResult from '../../../../components/results/NoItemResult';

const DealerSelectorEmpty = () => {
    const { t } = useTranslation();

    return <NoItemResult subTitle={t('common:dealerSelector.empty')} />;
};

export default DealerSelectorEmpty;
